import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TOAST_TYPES } from "../../toast-constants";
import styles from "./toast-icon.module.scss";

const ToastIcon = ({ type }) => {
  let icon = "";
  switch (type) {
    case TOAST_TYPES.INFO:
      icon = "info-circle";
      break;
    case TOAST_TYPES.WARN:
      icon = "exclamation-triangle";
      break;
    case TOAST_TYPES.ERROR:
      icon = "ban";
      break;
    case TOAST_TYPES.SUCCESS:
      icon = "check-circle";
      break;
    default:
      break;
  }
  if (!icon) return null;
  return (
    <div className={styles.toastIcon}>
      <FontAwesomeIcon className={styles[type]} size="md" icon={icon} />
    </div>
  );
};

export default ToastIcon;
